<template>
  <div class="widget-attachment-full-name">
    <div class="widget-attachment-full-name__name">
      <span>{{ nameWithoutExtension }}</span>
      <span v-if="extension">.</span>
    </div>
    <div
      v-if="extension"
      class="widget-attachment-full-name__extension"
    >
      {{ extension }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from '@/composition/vue/compositionApi'

const { name } = defineProps<{
  name: string // file.pdf
}>()

const nameWithoutExtension = computed(() => name.split('.').slice(0, -1).join('.'))
const extension = computed(() => name.split('.').slice(-1)[0])
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';
@import '@/styles/mixins.scss';

.widget-attachment-full-name {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: $medium-font;
  line-height: 20px;
  color: var(--widget-attachment-full-name-color, #{$neutral});

  &__name {
    @include truncate();
    flex-shrink: 1;
    flex-grow: 0;
  }

  &__extension {
    flex-shrink: 0;
    flex-grow: 0;
  }
}
</style>
